var _path, _path2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8343c8",
    d: "M41.754,27.958l-8.455,9.699C33.109,37.875,32.834,38,32.545,38H26.37 c-0.239,0-0.47,0.085-0.651,0.241l-6.438,5.519C19.1,43.915,18.869,44,18.63,44H17c-0.552,0-1-0.448-1-1v-4c0-0.552-0.448-1-1-1H7 c-0.552,0-1-0.448-1-1V15.943c0-0.156,0.036-0.309,0.106-0.448l3.981-7.943C10.257,7.214,10.603,7,10.981,7H41c0.552,0,1,0.448,1,1 v19.301C42,27.543,41.913,27.776,41.754,27.958z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M39,26.369c-1.667,1.877-3.333,3.754-5,5.631c-2.333,0-4.667,0-7,0c-2.333,2-4.667,4-7,6c0-2,0-4,0-6 c-2.667-0.008-5.333-0.016-8-0.024C12,24.65,12,17.325,12,10c9,0,18,0,27,0C39,15.456,39,20.912,39,26.369z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    x: 21,
    y: 16,
    fill: "#8343c8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    x: 30,
    y: 16,
    fill: "#8343c8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchIcon);
export default __webpack_public_path__ + "static/media/twitch-icon.ec9f57bb67004891de68495c401c395c.svg";
export { ForwardRef as ReactComponent };